import { SAVE_USER_INFORMATION, SAVE_ASSESSMENT, SAVE_DICTIONARY, SAVE_ANSWERERINFO } from './types';

export default {
  [SAVE_USER_INFORMATION]: (state, userInformation) => {
    state.userInformation = userInformation;
  },
  [SAVE_ASSESSMENT]: (state, assessment) => {
    state.assessment = assessment;
  },
  [SAVE_DICTIONARY]: (state, dictionary) => {
    state.dictionary = dictionary;
  },
  [SAVE_ANSWERERINFO]: (state, answererInfo) => {
    state.answererInfo = answererInfo;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js